import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// This is the only file that should directly import Raven.
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import uniq from 'lodash/uniq';
var getFragmentNames = function getFragmentNames(stackTrace) {
  var re = /(?:src\/entry|src|assets)\/([^,./]+)/g;
  var fragmentNames = [];
  var fragmentName = re.exec(stackTrace);
  while (fragmentName) {
    fragmentNames.push(fragmentName[1]);
    fragmentName = re.exec(stackTrace);
  }
  var distinctfragmentNames = uniq(fragmentNames);
  return distinctfragmentNames;
};

// Add custom tags based on stack trace
var getTaggedData = function getTaggedData(data, hint) {
  if (!hint) {
    return data;
  }
  var exception = hint.originalException || hint.syntheticException;
  if (!exception) {
    return data;
  }
  var stackTrace = exception.stack;
  if (!stackTrace) {
    return data;
  }
  var taggedData = data;
  var fragmentNames = getFragmentNames(stackTrace);
  if (!fragmentNames.length) {
    taggedData.tags = _objectSpread(_objectSpread({}, taggedData.tags), {}, {
      fragment: 'unknown'
    });
  } else {
    taggedData.tags = _objectSpread(_objectSpread({}, taggedData.tags), {}, {
      fragment: fragmentNames[0]
    });
    if (fragmentNames.length > 1) {
      taggedData.extra = _objectSpread(_objectSpread({}, taggedData.extra), {}, {
        allRelevantFragments: fragmentNames
      });
    }
  }
  return taggedData;
};

// https://docs.sentry.io/platforms/javascript/#removing-an-integration
var getFilteredIntegrations = function getFilteredIntegrations(integrations) {
  return integrations.filter(function (_ref) {
    var name = _ref.name;
    return name !== 'Breadcrumbs';
  });
};
var installGlobalHandler = function installGlobalHandler(sentryUrl, config, getExtraContext) {
  // Check for sentry already enabled to be defensive in case two fragments are loaded in the same page, we
  // don't want duplicated error reports
  var sentryClient = Sentry.getCurrentHub().getClient();
  if (sentryClient && sentryClient.getOptions().enabled) {
    return;
  }
  var defaultConfig = {
    dsn: sentryUrl,
    environment: process.env.NODE_ENV,
    // This adds our tags to the data sent to sentry
    beforeSend: function beforeSend(event, hint) {
      // Yes, we're mutating the argument, but at this point in the error handling lifecycle
      // immutability is not important and it simplifies the logic
      // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
      var extraBeforeSend = config.beforeSend || function () {
        return null;
      };
      var updatedData = extraBeforeSend(event, hint);
      updatedData = getTaggedData(updatedData, hint);
      return updatedData;
    },
    //Integration typing doesn't seem to work well so I'm just typing it to any
    integrations: function integrations(_integrations) {
      return [].concat(_toConsumableArray(getFilteredIntegrations(_integrations)), [new Integrations.Dedupe(), new Integrations.ExtraErrorData(), new Integrations.Transaction(), new Integrations.CaptureConsole({
        levels: ['error']
      })], _toConsumableArray(config.integrations && config.integrations instanceof Array ? config.integrations : []));
    }
  };

  // Because we don't want to completely override the platform defaults remove them from the config object.
  // They've been integrated into the defaultConfig above.
  config.beforeSend = undefined;
  config.integrations = undefined;
  Sentry.init(_objectSpread(_objectSpread({}, defaultConfig), config));
  try {
    Sentry.setExtras(getExtraContext());
  } catch (e) {
    Sentry.captureException(e);
  }
};
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
var tags = ['packageName', 'teamName'];
var captureException = function captureException(location, error) {
  var details = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  Sentry.configureScope(function (scope) {
    scope.setTag('logger', location);
    if (details) {
      Object.keys(details).forEach(function (key) {
        if (tags.includes(key)) {
          scope.setTag(key, details[key]);
        } else {
          scope.setExtra(key, details[key]);
        }
      });
    }
  });
  Sentry.captureException(error);
};
export default {
  installGlobalHandler: installGlobalHandler,
  captureException: captureException
};